export default __webpack_public_path__ + "static/media/uploadPolicy.1f11392e.svg";